import React from "react";
import { Typography } from "@material-ui/core"

function Notifications() {
    return (
        <div id="loading-page">
            <div className="waiting-baloon"></div>
            <div className="waiting-baloon"></div>
            <Typography color="textPrimary" variant="h3" >Facematik</Typography>
            <div className="waiting-baloon"></div>
            <div className="waiting-baloon"></div>
        </div>
    );
}
export default Notifications;
